const initialState = {
    planLoading: false,
    planData: {},
    planError: '',
}

const ProductReducer = (state = initialState, action) => {
    switch(action.type){
        case 'PLAN_LOADING':
            return {
                ...state,
                planLoading: true
            }
        case 'GET_PLAN_SUCCESS':
            return{
                ...state,
                planLoading: false,
                planData: action.payload
            }
        case 'GET_PLAN_FAILURE':
            return{
                ...state,
                planLoading: false,
                planError:action.payload
            }
        default: return state
    }
}

export default ProductReducer